import React from "react";
import classnames from "classnames";

function buildColumnClass(prefix, value) {
  if (value === undefined || value === null || value === false) {
    return null;
  }

  if (value === true) {
    return prefix;
  }

  return `${prefix}-${value}`;
}

export function Container({ children, className = "", ...rest }) {
  return (
    <div className={classnames("container", className)} {...rest}>
      {children}
    </div>
  );
}

export function Row({ children, className = "", ...rest }) {
  return (
    <div className={classnames("row", className)} {...rest}>
      {children}
    </div>
  );
}

export function Col({
  children,
  className = "",
  xs,
  sm,
  md,
  lg,
  xl,
  xxl,
  ...rest
}) {
  const classes = [
    buildColumnClass("col", xs),
    buildColumnClass("col-sm", sm),
    buildColumnClass("col-md", md),
    buildColumnClass("col-lg", lg),
    buildColumnClass("col-xl", xl),
    buildColumnClass("col-xxl", xxl),
  ].filter(Boolean);

  if (!classes.length) {
    classes.push("col");
  }

  return (
    <div className={classnames(classes, className)} {...rest}>
      {children}
    </div>
  );
}
